<script lang="ts" setup>
import { computed } from 'vue'
import { createGAEvent, GaGeneralEvent } from '@/assets/ts/customEvent'

const props = defineProps({
	link: {
		type: String,
		required: true,
	},
	icon: {
		type: String,
		default: '',
	},
	name: {
		type: String,
		required: true,
	},
	isNewBadge: {
		type: Boolean,
		default: false,
	},
	newBadgeText: {
		type: String,
		default: 'New',
	},
	desc: {
		type: String,
		default: '',
	},
	isDisabled: {
		type: Boolean,
		default: false,
	},
	action: {
		type: Function,
	},
	gaButtonName: {
		type: String,
		default: '',
	},
})

const finalLink = computed(() => {
	if (props.isDisabled || props.action) {
		return 'javascript:void(0);'
	}
	return props.link
})

function sendGaEvent() {
	createGAEvent(GaGeneralEvent.ButtonClick, {
		button_name: props.gaButtonName,
		page_name: '',
	})
}

function clickItem() {
	if (props.isDisabled) {
		return
	}
	if (props.gaButtonName) {
		sendGaEvent()
	}
	if (props.action) {
		props.action()
	}
}
</script>

<template>
	<a
		class="bs-nav-dropdown-item"
		:href="isDisabled ? 'javascript:void(0);' : finalLink"
		:class="{ disabled: isDisabled }"
		@click="clickItem"
	>
		<div class="bs-nav-dropdown-item__first-layer">
			<div class="bs-nav-dropdown-item__icon" v-if="icon">
				<i :class="[`bs-nav-dropdown-item__icon--${icon}`]"></i>
			</div>
			<div class="bs-nav-dropdown-item__name">{{ name }}</div>
			<div class="bs-nav-dropdown-item__badge" v-if="isNewBadge">
				{{ newBadgeText }}
			</div>
		</div>
		<div
			:class="['bs-nav-dropdown-item__desc', { 'icon-not-exist': !icon }]"
			v-if="desc"
		>
			{{ desc }}
		</div>
	</a>
</template>
